import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
/* eslint-disable max-lines */
import { all, call, put, select, take, takeLatest } from 'redux-saga/effects';
import { getAuthCookie, removeAuthCookie, setAuthCookie } from '../../helpers/CookieHelpers';
import { redirect } from '../../helpers/UrlHelpers';
import routes, { Router } from '../../routes';
import ApiSagas from '../api/sagas';
import { selectors as AppSelectors } from '../app/redux';
import * as configuration from '../../configuration';
import { APPLICATIONS_SECTIONS } from '../../graphql/enums/applicationSections';
import { selectors as AuthSelectors, actions, selectors } from './redux';
import * as services from './services';
import { CandidateTransformer } from './transformers';
var DEBUG = configuration.api.DEBUG;
var log = DEBUG ? console.log : function () {
  return null;
};
var AuthSagas = /*#__PURE__*/function () {
  function AuthSagas() {
    _classCallCheck(this, AuthSagas);
  }
  return _createClass(AuthSagas, null, [{
    key: "init",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function init(ctx) {
      var cookie, token;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            AuthSagas.req = ctx == null ? void 0 : ctx.req;
            AuthSagas.res = ctx == null ? void 0 : ctx.res;
            cookie = getAuthCookie(AuthSagas.req);
            _context.next = 1;
            return select(selectors.token);
          case 1:
            token = _context.sent;
            if (process.browser) {
              _context.next = 2;
              break;
            }
            _context.next = 2;
            return put(actions.setUser(null));
          case 2:
            if (!cookie) {
              _context.next = 5;
              break;
            }
            if (!(!token || (token == null ? void 0 : token.accessToken) !== (cookie == null ? void 0 : cookie.accessToken))) {
              _context.next = 4;
              break;
            }
            _context.next = 3;
            return put(actions.setToken(cookie));
          case 3:
            _context.next = 4;
            return take(actions.setUser.getType());
          case 4:
            _context.next = 7;
            break;
          case 5:
            if (!token) {
              _context.next = 7;
              break;
            }
            _context.next = 6;
            return put(actions.setToken(null));
          case 6:
            _context.next = 7;
            return take(actions.setUser.getType());
          case 7:
            _context.next = 8;
            return call(AuthSagas.redirectLogged, ctx);
          case 8:
          case "end":
            return _context.stop();
        }
      }, init);
    })
  }, {
    key: "redirectToPage",
    value: function redirectToPage() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : AuthSagas.res;
      var destinationRoute = arguments.length > 1 ? arguments[1] : undefined;
      return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return call(redirect, res, Router.getRouteUrl(destinationRoute), 303);
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee);
      })();
    }
  }, {
    key: "redirectHome",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function redirectHome() {
      var isConnected;
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 1;
            return select(selectors.isConnected);
          case 1:
            isConnected = _context3.sent;
            if (isConnected) {
              _context3.next = 3;
              break;
            }
            _context3.next = 2;
            return call(AuthSagas.redirectLogged);
          case 2:
            return _context3.abrupt("return", _context3.sent);
          case 3:
            _context3.next = 4;
            return call(AuthSagas.redirectLogged);
          case 4:
            return _context3.abrupt("return", _context3.sent);
          case 5:
          case "end":
            return _context3.stop();
        }
      }, redirectHome);
    })
  }, {
    key: "redirectLogged",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function redirectLogged() {
      var _AuthSagas$req, _AuthSagas$req2, _AuthSagas$req3, _AuthSagas$req4;
      var isConnected, _yield$select, pathname, user, authRoutes;
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 1;
            return select(selectors.isConnected);
          case 1:
            isConnected = _context4.sent;
            _context4.next = 2;
            return select(AppSelectors.route);
          case 2:
            _yield$select = _context4.sent;
            pathname = _yield$select.pathname;
            _context4.next = 3;
            return select(AuthSelectors.user);
          case 3:
            user = _context4.sent;
            if (!(!isConnected && ((AuthSagas == null ? void 0 : (_AuthSagas$req = AuthSagas.req) == null ? void 0 : _AuthSagas$req.url) === '/home' || (AuthSagas == null ? void 0 : (_AuthSagas$req2 = AuthSagas.req) == null ? void 0 : _AuthSagas$req2.url) === '/'))) {
              _context4.next = 5;
              break;
            }
            _context4.next = 4;
            return call(AuthSagas.redirectToPage, AuthSagas.res, routes.scholarship);
          case 4:
            return _context4.abrupt("return", true);
          case 5:
            if (!(pathname === routes.page.component && (AuthSagas == null ? void 0 : (_AuthSagas$req3 = AuthSagas.req) == null ? void 0 : _AuthSagas$req3.url) !== '/home' && (AuthSagas == null ? void 0 : (_AuthSagas$req4 = AuthSagas.req) == null ? void 0 : _AuthSagas$req4.url) !== '/')) {
              _context4.next = 6;
              break;
            }
            return _context4.abrupt("return", true);
          case 6:
            authRoutes = Object.values(routes).filter(function (route) {
              return route.auth;
            }).map(function (route) {
              return route.component;
            });
            if (!(!isConnected && authRoutes.includes(pathname))) {
              _context4.next = 8;
              break;
            }
            log('Auth: redirect to login', {
              current: pathname,
              dest: routes.about.component
            });
            _context4.next = 7;
            return call(AuthSagas.redirectToPage, AuthSagas.res, routes.login);
          case 7:
            return _context4.abrupt("return", true);
          case 8:
            if (!(isConnected && user.accepts_disclaimer && user.started_at && user.sent_at && pathname !== routes.thankyou.component)) {
              _context4.next = 10;
              break;
            }
            log('Auth: user has submit application');
            _context4.next = 9;
            return call(AuthSagas.redirectToPage, AuthSagas.res, routes.thankyou);
          case 9:
            return _context4.abrupt("return", true);
          case 10:
            if (!(isConnected && user.accepts_disclaimer && user.started_at && !user.sent_at && ![routes.applicationCv.component, routes.applicationBackground.component, routes.applicationPersonal.component, routes.applicationPortfolio.component, routes.applicationSubmit.component].includes(pathname))) {
              _context4.next = 20;
              break;
            }
            log('Auth: user has started start form but not completed yet');
            if (!user.invalid_sections.includes(APPLICATIONS_SECTIONS.SECTION_CV)) {
              _context4.next = 12;
              break;
            }
            _context4.next = 11;
            return call(AuthSagas.redirectToPage, AuthSagas.res, routes.applicationCv);
          case 11:
            return _context4.abrupt("return", true);
          case 12:
            if (!user.invalid_sections.includes(APPLICATIONS_SECTIONS.SECTION_BACKGROUND)) {
              _context4.next = 14;
              break;
            }
            _context4.next = 13;
            return call(AuthSagas.redirectToPage, AuthSagas.res, routes.applicationBackground);
          case 13:
            return _context4.abrupt("return", true);
          case 14:
            if (!user.invalid_sections.includes(APPLICATIONS_SECTIONS.SECTION_PERSONAL_STATEMENT)) {
              _context4.next = 16;
              break;
            }
            _context4.next = 15;
            return call(AuthSagas.redirectToPage, AuthSagas.res, routes.applicationPersonal);
          case 15:
            return _context4.abrupt("return", true);
          case 16:
            if (!user.invalid_sections.includes(APPLICATIONS_SECTIONS.SECTION_PORTFOLIO)) {
              _context4.next = 18;
              break;
            }
            _context4.next = 17;
            return call(AuthSagas.redirectToPage, AuthSagas.res, routes.applicationPortfolio);
          case 17:
            return _context4.abrupt("return", true);
          case 18:
            _context4.next = 19;
            return call(AuthSagas.redirectToPage, AuthSagas.res, routes.applicationCv);
          case 19:
            return _context4.abrupt("return", true);
          case 20:
            if (!(isConnected && user.accepts_disclaimer && !user.started_at && ![routes.about.component, routes.start.component, routes.submitSchool.component].includes(pathname))) {
              _context4.next = 22;
              break;
            }
            log('Auth: user is logged in - has accepted disclaimer - go to about page');
            _context4.next = 21;
            return call(AuthSagas.redirectToPage, AuthSagas.res, routes.about);
          case 21:
            return _context4.abrupt("return", true);
          case 22:
            if (!(isConnected && !user.accepts_disclaimer && pathname !== routes.disclaimer.component)) {
              _context4.next = 24;
              break;
            }
            log('Auth: user is logged in but need to accept disclaimer - then redirect to disclaimer');
            _context4.next = 23;
            return call(AuthSagas.redirectToPage, AuthSagas.res, routes.disclaimer);
          case 23:
            return _context4.abrupt("return", true);
          case 24:
          case "end":
            return _context4.stop();
        }
      }, redirectLogged);
    })
  }, {
    key: "updateCv",
    value: function updateCv(_ref) {
      var payload = _ref.payload;
      return /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var stepKeys, filteredPayload, index, screenKey, cvPayload, result, _result$data;
        return _regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              stepKeys = payload.fields.map(function (e) {
                return e.name;
              });
              filteredPayload = {};
              for (index = 0; index < stepKeys.length; index++) {
                screenKey = stepKeys[index];
                filteredPayload[screenKey] = payload.cv[screenKey];
              }
              cvPayload = CandidateTransformer(filteredPayload);
              _context5.next = 1;
              return call(ApiSagas.query, services.updateCv, cvPayload);
            case 1:
              result = _context5.sent;
              if (!(result != null && result.data || !result.errors)) {
                _context5.next = 2;
                break;
              }
              _context5.next = 2;
              return put(actions.setUser(result == null ? void 0 : (_result$data = result.data) == null ? void 0 : _result$data.updateCv));
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee2);
      })();
    }
  }, {
    key: "updateFiles",
    value: function updateFiles(_ref2) {
      var payload = _ref2.payload;
      return /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var user, newFiles, toDeleteFiles, toCreateFiles, toEditFiles, result, _result$data$updateFi, _result$data2, _result$data2$updateF, _result$data$updateFi2, _result$data3, _result$data3$updateF, _result$data$updateFi3, _result$data4, _result$data4$updateF, mutatedUser;
        return _regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 1;
              return select(AuthSelectors.user);
            case 1:
              user = _context6.sent;
              newFiles = Array.from(Array(Object.keys(payload).length / 2), function (d, i) {
                return {
                  description: payload["description_".concat(i)],
                  file: payload["file_".concat(i)]
                };
              });
              toDeleteFiles = newFiles.filter(function (val) {
                return val.file.filename === '' && typeof val.file.id !== 'undefined';
              });
              toCreateFiles = newFiles.filter(function (val) {
                return val.description !== '' && val.file !== '' && val.file.id && val.file.filename;
              }).filter(function (newFile) {
                var _user$files;
                var isAlreadyExists = user == null ? void 0 : (_user$files = user.files) == null ? void 0 : _user$files.find(function (file) {
                  return file.id === newFile.file.id;
                });
                if (isAlreadyExists) {
                  return false;
                }
                return true;
              });
              toEditFiles = toCreateFiles.length === 0 ? newFiles.filter(function (newFile) {
                var _user$files2;
                var initialValue = user == null ? void 0 : (_user$files2 = user.files) == null ? void 0 : _user$files2.find(function (file) {
                  return file.id === newFile.file.id;
                });
                if (typeof newFile.file.id !== 'undefined' && newFile.description !== '' && (newFile == null ? void 0 : newFile.description) !== (initialValue == null ? void 0 : initialValue.description)) {
                  return true;
                }
              }) : [];
              if (!(toCreateFiles.length === 0 && toDeleteFiles.length === 0 && toEditFiles.length === 0)) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              _context6.next = 3;
              return call(ApiSagas.query, services.updateFiles, {
                create: toCreateFiles.map(function (elem) {
                  return {
                    description: elem.description,
                    path: elem.file.id,
                    filename: elem.file.filename
                  };
                }),
                update: toEditFiles.map(function (elem) {
                  return {
                    id: elem.file.id,
                    description: elem.description
                  };
                }),
                "delete": toDeleteFiles.map(function (elem) {
                  return elem.file.id;
                })
              });
            case 3:
              result = _context6.sent;
              if (!(result != null && result.data || !result.errors)) {
                _context6.next = 4;
                break;
              }
              mutatedUser = _objectSpread({}, user);
              mutatedUser.files = (_result$data$updateFi = result == null ? void 0 : (_result$data2 = result.data) == null ? void 0 : (_result$data2$updateF = _result$data2.updateFiles) == null ? void 0 : _result$data2$updateF.files) !== null && _result$data$updateFi !== void 0 ? _result$data$updateFi : user.files;
              mutatedUser.is_complete = (_result$data$updateFi2 = result == null ? void 0 : (_result$data3 = result.data) == null ? void 0 : (_result$data3$updateF = _result$data3.updateFiles) == null ? void 0 : _result$data3$updateF.is_complete) !== null && _result$data$updateFi2 !== void 0 ? _result$data$updateFi2 : user.is_complete;
              mutatedUser.invalid_sections = (_result$data$updateFi3 = result == null ? void 0 : (_result$data4 = result.data) == null ? void 0 : (_result$data4$updateF = _result$data4.updateFiles) == null ? void 0 : _result$data4$updateF.invalid_sections) !== null && _result$data$updateFi3 !== void 0 ? _result$data$updateFi3 : user.invalid_sections;
              _context6.next = 4;
              return put(actions.setUser(mutatedUser));
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee3);
      })();
    }
  }, {
    key: "logout",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function logout() {
      return _regeneratorRuntime.wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 1;
            return all([put(actions.setToken(null)), call(ApiSagas.query, services.logout)]);
          case 1:
            _context7.next = 2;
            return call(redirect, null, Router.getRouteUrl(routes.scholarship), 303);
          case 2:
          case "end":
            return _context7.stop();
        }
      }, logout);
    })
  }, {
    key: "loadMe",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function loadMe() {
      var token, result;
      return _regeneratorRuntime.wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 1;
            return select(selectors.token);
          case 1:
            token = _context8.sent;
            if (!token) {
              _context8.next = 3;
              break;
            }
            _context8.next = 2;
            return call(ApiSagas.query, services.me);
          case 2:
            result = _context8.sent;
            if (!(result != null && result.data || !result.errors)) {
              _context8.next = 3;
              break;
            }
            _context8.next = 3;
            return put(actions.setUser(result == null ? void 0 : result.data));
          case 3:
          case "end":
            return _context8.stop();
        }
      }, loadMe);
    })
  }, {
    key: "onToken",
    value: function onToken(_ref3) {
      var payload = _ref3.payload;
      return /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var token, result;
        return _regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              token = payload;
              log('Auth: onToken', !!token);
              if (!token) {
                _context9.next = 5;
                break;
              }
              _context9.next = 1;
              return call(ApiSagas.query, services.me);
            case 1:
              result = _context9.sent;
              if (!(result != null && result.data || !result.errors)) {
                _context9.next = 3;
                break;
              }
              log('Auth: save new token');
              setAuthCookie(token);
              _context9.next = 2;
              return put(actions.setUser(result == null ? void 0 : result.data));
            case 2:
              return _context9.abrupt("return");
            case 3:
              log('Auth: Remove token', result.errors);
              _context9.next = 4;
              return put(actions.setToken(null));
            case 4:
              return _context9.abrupt("return");
            case 5:
              log('Auth: Remove token, remove user');
              removeAuthCookie(AuthSagas.req);
              _context9.next = 6;
              return put(actions.setUser(null));
            case 6:
            case "end":
              return _context9.stop();
          }
        }, _callee4);
      })();
    }
  }, {
    key: "loop",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function loop() {
      return _regeneratorRuntime.wrap(function (_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 1;
            return all([takeLatest(actions.setToken.getType(), AuthSagas.onToken), takeLatest(actions.logout.getType(), AuthSagas.logout), takeLatest(actions.loadMe.getType(), AuthSagas.loadMe), takeLatest(actions.updateCv.getType(), AuthSagas.updateCv), takeLatest(actions.updateFiles.getType(), AuthSagas.updateFiles)]);
          case 1:
          case "end":
            return _context10.stop();
        }
      }, loop);
    })
  }]);
}();
_defineProperty(AuthSagas, "req", null);
_defineProperty(AuthSagas, "res", null);
export { AuthSagas as default };